import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; 
import axios from "axios";
import CreatorCard from "../components/CreatorCard";
import RecommendedCard from "../components/RecommendedCard";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function Home() {
  const [creators, setCreators] = useState([]);
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE}/submissions?type=creator&limit=18`)
      .then((res) => setCreators(res.data))
      .catch((err) => console.error("Error fetching creators:", err));

    axios
      .get(`${API_BASE}/submissions?type=recommendation&limit=18`)
      .then((res) => setRecommendations(res.data))
      .catch((err) => console.error("Error fetching recommendations:", err));
  }, []);

  return (
    <div>
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "20px",
          textAlign: "center",
          fontFamily: "'Nunito', sans-serif",
        }}
      >
        <h1>Welcome creators & supporters!</h1>
        <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>
          Share Your Kofi is a simple community-driven directory where
          <a
            href="https://ko-fi.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#4dabf7",
              textDecoration: "underline",
              marginLeft: "5px",
            }}
          >
            Ko-fi
          </a>{" "}
          creators can showcase their pages and fans can recommend their
          favorites. It's built to help more creators get discovered — one
          submission at a time!
        </p>
        <p style={{ fontSize: "0.8rem", color: "#999", marginTop: "20px" }}>
          <strong>Disclaimer:</strong> Share Your Kofi is an independent,
          fan-created project and is not affiliated with Ko-fi.com or the
          official Ko-fi team. Listings are community-submitted. We do not vet, verify, or endorse any creator. Please do your own research before supporting anyone.
        </p>
      </div>

      <h2>Latest Creator Submissions</h2>
      <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>
      Explore creator profiles below, support them, or simply get inspired! Search by Filter available in, "All Creators" page. 
      If you are a creator or would like to see creators listed in a box like below, please visit the “Submit” page. 
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "20px",
        }}
      >
        {creators.map((sub) => (
          <CreatorCard key={sub._id} submission={sub} />
        ))}
      </div>

      {/* View All Creators Button */}
      {creators.length > 0 && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Link
            to="/creators"
            style={{
              display: "inline-block",
              padding: "10px 20px",
              backgroundColor: "#4dabf7",
              color: "#fff",
              textDecoration: "none",
              borderRadius: "20px",
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            View All Creators
          </Link>
        </div>
      )}

      <hr style={{ margin: "30px 0" }} />

      <h2>Fan Recommendations</h2>
      <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>
        Discover amazing Ko-fi creators recommended by their fans and supporters!
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "12px",
        }}
      >
        {recommendations.map((sub) => (
          <RecommendedCard key={sub._id} submission={sub} />
        ))}
      </div>

      {/* View All Recommendations Button */}
      {recommendations.length > 0 && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Link
            to="/recommended"
            style={{
              display: "inline-block",
              padding: "10px 20px",
              backgroundColor: "#4dabf7",
              color: "#fff",
              textDecoration: "none",
              borderRadius: "20px",
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            View All Recommendations
          </Link>
        </div>
      )}
    </div>
  );
}

export default Home;

